export default {
  computed: {
    userIsUsingBlueSnap () {
      const paymentGateway = this.$store.state.header?.headerData?.paymentGateway ?? 'braintree';
      return paymentGateway !== 'braintree' ?? false;
    }
  },
}